export class ChatFakeDb
{
    public static contacts = [
        {
            'id'    : '1',
            'name'  : 'Contact 1',
            'avatar': 'assets/images/avatars/alice.jpg',
            'status': 'online',
            'mood'  : 'GPTW technical support.'
        },
        {
            'id'    : '2',
            'name'  : 'Contact 2',
            'avatar': 'assets/images/avatars/Arnold.jpg',
            'status': 'do-not-disturb',
            'mood'  : 'GPTW technical support.'
        },
        {
            'id'    : '3',
            'name'  : 'Contact 3',
            'avatar': 'assets/images/avatars/Barrera.jpg',
            'status': 'online',
            'mood'  : 'Cultural Go technical support.',
            'unread': null
        }
    ];

    public static chats = [
        {
            'id'    : '10',
            'dialog': [
                {
                    'who'    : '2',
                    'message': 'Quickly come to the meeting room 1B, we have a big server issue',
                    'time'   : '2017-04-22T01:00:00.299Z'
                },
                {
                    'who'    : '100',
                    'message': 'I’m having breakfast right now, can’t you wait for 10 minutes?',
                    'time'   : '2017-04-22T01:05:00.299Z'
                },
                {
                    'who'    : '2',
                    'message': 'We are losing money! Quick!',
                    'time'   : '2017-04-22T01:10:00.299Z'
                }
            ]
        }
    ];

    public static user = [
        {
            'id'      : '100',
            'name'    : 'Juancho',
            'avatar'  : 'assets/images/avatars/profile.jpg',
            'status'  : 'online',
            'mood'    : 'it\'s a status....not your diary...',
            'chatList': [
                {
                    'id'             : '10',
                    'contactId'      : '2',
                    'name'           : 'Contacto 2',
                    'unread'         : 1,
                    'lastMessage'    : 'We are losing money! Quick!',
                    'lastMessageTime': '2017-06-12T02:10:18.931Z'
                }
            ]
        }
    ];

}
